// extracted by mini-css-extract-plugin
export default {"gradientPath":"SparklesIcon_gradientPath__2nCAS","active":"SparklesIcon_active__NcnwV"};